import type { I18nService } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';

import type { Source } from './types';
import { FieldMappingSource } from './types';

export const sourceIcon = (source: FieldMappingSource): IconName => {
  // eslint-disable-next-line default-case
  switch (source) {
    case FieldMappingSource.CUSTOM_FIELD:
      return 'content-paste';

    case FieldMappingSource.OPEN_QUESTION:
      return 'assignment';

    case FieldMappingSource.QUESTIONNAIRE_QUESTION:
      return 'question-answer';
  }
};

export const sourceName = (
  source: Pick<Source, 'name' | 'type' | 'metadata'>,
  i18n: I18nService,
) => {
  if (source.name || source.type !== FieldMappingSource.CUSTOM_FIELD) return source.name;

  return customFieldName(i18n)[source.metadata.kind];
};

const customFieldName = (i18n: I18nService): { [key: string]: string } => ({
  address: i18n.translate('app.custom_fields.types.address'),
  date_of_birth: i18n.translate('app.custom_fields.types.date_of_birth'),
  gender: i18n.translate('app.custom_fields.types.gender'),
  language_skill: i18n.translate('app.custom_fields.types.language_skill'),
  nationality: i18n.translate('app.custom_fields.types.nationality'),
  skills: i18n.translate('app.custom_fields.types.skills'),
});

export const sourceCompoundId = (source: Pick<Source, 'id' | 'type'>): string =>
  `${source.type}:${source.id}`;
